"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _i18next = require("i18next");

var _jspdf = _interopRequireDefault(require("jspdf"));

require("jspdf-autotable");

var _tables = require("./tables");

var _browsers = require("../../browsers");

var _Logger = _interopRequireDefault(require("../../Logger"));

var _index = _interopRequireDefault(require("../../locale/index"));

var _Montserrat = require("../../assets/fonts/Montserrat");

var _colors = require("../../colors");

/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/extensions
var resources = {};
Object.keys(_index["default"]).forEach(function (locale) {
  resources[locale] = {
    translation: _index["default"][locale].translations
  };
});
var DEFAULT_LANGUAGE = 'sv';

var getMerchantLogo = function getMerchantLogo(logo) {
  return new Promise(function (resolve, reject) {
    if (_browsers.isNode) {
      if (!logo) {
        resolve();
        return;
      } // eslint-disable-next-line global-require


      var https = require('https');

      https.get(logo, function (res) {
        var data = [];
        var contentType = res.headers['content-type'];
        res.on('data', function (chunk) {
          data.push(chunk);
        });
        res.on('end', function () {
          if (contentType === 'application/xml') {
            _Logger["default"].error("Logo could not be found in ".concat(logo, "."));

            resolve();
          } else {
            resolve("data:".concat(contentType, ";base64, ").concat(Buffer.concat(data).toString('base64')));
          }
        });
      }).on('error', function (error) {
        _Logger["default"].error(error);

        reject(error);
      });
    } else if (_browsers.isBrowser) {
      var img = new Image();
      img.src = "".concat(logo, "?r=").concat(Math.floor(Math.random() * 1000000));
      img.crossOrigin = 'anonymous';
      resolve(img);
    }
  });
};

var createInvoice = function createInvoice(invoiceData) {
  var returnType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'save';
  return new Promise(function (resolve, reject) {
    var language = invoiceData.language,
        merchant = invoiceData.merchant,
        customer = invoiceData.customer,
        order = invoiceData.order,
        id = invoiceData.id,
        notes = invoiceData.notes;
    var lang = language || DEFAULT_LANGUAGE;
    (0, _i18next.createInstance)({
      resources: resources,
      lng: lang,
      keySeparator: '.',
      interpolation: {
        escapeValue: false // react already safes from xss

      }
    }, /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(err, translate) {
        var _order$items, _order$fees;

        var itemsHeader, pdf, setTextColor, cleanArray, img, imgProps, imageWidth, isBoldOpen, itemsTable, summaryTable, vatIndex, totalPages, i;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                itemsHeader = [{
                  text: translate('pdf.invoice.table.itemName'),
                  align: 'left'
                }, {
                  text: translate('pdf.invoice.table.itemId'),
                  align: 'center'
                }, {
                  text: translate('pdf.invoice.table.qty'),
                  align: 'center'
                }, {
                  text: translate('pdf.invoice.table.price'),
                  align: 'left'
                }, {
                  text: translate('pdf.invoice.table.vat'),
                  align: 'center'
                }, {
                  text: translate('pdf.invoice.table.total'),
                  align: 'right'
                }];
                pdf = new _jspdf["default"]('p', 'px', 'a4');
                pdf.addFileToVFS('Montserrat-Bold.ttf', _Montserrat.MontserratBold);
                pdf.addFont('Montserrat-Bold.ttf', 'Montserrat', 'bold');
                pdf.addFileToVFS('Montserrat-Regular.ttf', _Montserrat.Montserrat);
                pdf.addFont('Montserrat-Regular.ttf', 'Montserrat', 'normal');
                pdf.addFileToVFS('Montserrat-Medium.ttf', _Montserrat.MontserratMedium);
                pdf.addFont('Montserrat-Medium.ttf', 'Montserrat', 'medium');

                setTextColor = function setTextColor(hexColor) {
                  var _hexToRgb = (0, _colors.hexToRgb)(hexColor),
                      r = _hexToRgb.r,
                      g = _hexToRgb.g,
                      b = _hexToRgb.b;

                  pdf.setTextColor(r, g, b);
                };

                cleanArray = function cleanArray(arr) {
                  return arr.filter(function (item) {
                    var content = item[0].content;

                    if (typeof content === 'string') {
                      return !content.includes('undefined') && !content.includes('<0>');
                    } else {
                      return content !== undefined;
                    }
                  });
                };

                _context.next = 12;
                return getMerchantLogo(merchant.logo);

              case 12:
                img = _context.sent;

                if (merchant.logo && img) {
                  imgProps = pdf.getImageProperties(img);
                  imageWidth = imgProps.width / imgProps.height * 24;
                  pdf.addImage(img, 'png', 36, 8, imageWidth, 24);
                }

                pdf.autoTable({
                  startY: merchant.logo ? 40 : 25,
                  styles: {
                    fontSize: 10
                  },
                  avoidPageSplit: true,
                  margin: {
                    left: 38
                  },
                  theme: 'plain',
                  body: cleanArray((0, _tables.createMerchantInfo)(merchant, translate))
                });
                pdf.autoTable({
                  startY: 22,
                  styles: {
                    fontSize: 10
                  },
                  margin: {
                    right: 38
                  },
                  theme: 'plain',
                  body: cleanArray((0, _tables.createInvoiceInfo)(invoiceData, translate))
                });
                pdf.autoTable({
                  startY: 92,
                  styles: {
                    fontSize: 10
                  },
                  margin: {
                    left: 263
                  },
                  theme: 'plain',
                  body: cleanArray((0, _tables.createCustomerInfo)(customer))
                });
                pdf.setDrawColor('#F2F2F2');
                pdf.setLineWidth(5.0);
                pdf.line(0, 176, 560, 176);
                pdf.autoTable({
                  startY: 208,
                  margin: {
                    left: 37
                  },
                  theme: 'plain',
                  body: cleanArray((0, _tables.createAmountInfo)(order, translate, lang))
                });

                isBoldOpen = function isBoldOpen(arrayLength) {
                  var valueBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var isEven = arrayLength % 2 === 0;
                  var result = valueBefore !== isEven;
                  return result;
                };

                pdf.autoTable({
                  startY: 189,
                  styles: {
                    fontSize: 10
                  },
                  margin: {
                    left: 262
                  },
                  theme: 'plain',
                  body: cleanArray((0, _tables.createPaymentDetails)(invoiceData, translate, lang)),
                  willDrawCell: function willDrawCell(data) {
                    var _data$cell$raw$conten;

                    // IBAN + SWIFT
                    if (data.row.index === 2 && (_data$cell$raw$conten = data.cell.raw.content) !== null && _data$cell$raw$conten !== void 0 && _data$cell$raw$conten.includes(':')) {
                      var textMap = pdf.splitTextToSize(data.cell.raw.content, 130);
                      var startXCached = data.cell.x;
                      var boldOpen = false;
                      textMap.map(function (text, i) {
                        if (text) {
                          var arrayOfNormalAndBoldText = text.split('**');
                          var boldStr = 'bold';
                          var normalOr = 'normal';
                          arrayOfNormalAndBoldText.map(function (textItems, j) {
                            pdf.setFont(undefined, boldOpen ? normalOr : boldStr);

                            if (j % 2 === 0) {
                              pdf.setFont(undefined, boldOpen ? boldStr : normalOr);
                            }

                            pdf.text(textItems, data.cell.x, data.cell.y + 6);
                            data.cell.x += pdf.getStringUnitWidth(textItems) * 8;
                          });
                          boldOpen = isBoldOpen(arrayOfNormalAndBoldText.length, boldOpen);
                          data.cell.x = startXCached;

                          if (i < textMap.length - 1) {
                            data.cell.y += 10;
                          }
                        }
                      });
                      data.row.height = 18;
                      data.cell.raw.content = '';
                      data.cell.text = [];
                    }
                  }
                });
                pdf.setDrawColor('#F2F2F2');
                pdf.setLineWidth(5.0);
                pdf.line(0, 286, 560, 286);
                pdf.autoTable({
                  startY: 320,
                  margin: {
                    left: 37
                  },
                  styles: {
                    fontSize: 9
                  },
                  theme: 'plain',
                  body: cleanArray((0, _tables.createOrderId)(order, translate))
                });

                if (order.date) {
                  pdf.autoTable({
                    startY: 320,
                    margin: {
                      right: 38
                    },
                    styles: {
                      fontSize: 9
                    },
                    theme: 'plain',
                    body: cleanArray((0, _tables.createOrderDate)(order, translate))
                  });
                }

                itemsTable = [];

                if ((_order$items = order.items) !== null && _order$items !== void 0 && _order$items.length) {
                  itemsTable.push.apply(itemsTable, (0, _toConsumableArray2["default"])((0, _tables.createBodyTable)(order.items, order, lang)));
                }

                if ((_order$fees = order.fees) !== null && _order$fees !== void 0 && _order$fees.length) {
                  itemsTable.push.apply(itemsTable, (0, _toConsumableArray2["default"])((0, _tables.createFeesTable)(order, translate, lang)));
                }

                pdf.autoTable({
                  startY: 350,
                  margin: {
                    left: 37,
                    right: 38
                  },
                  styles: {
                    fontSize: 9
                  },
                  theme: 'plain',
                  head: (0, _tables.createHeaderTable)(itemsHeader),
                  body: itemsTable,
                  columnStyles: {
                    0: {
                      cellWidth: 125
                    },
                    1: {
                      cellWidth: 50
                    },
                    2: {
                      cellWidth: 50
                    },
                    3: {
                      cellWidth: 50
                    },
                    4: {
                      cellWidth: 50
                    }
                  },
                  willDrawCell: function willDrawCell(data) {
                    var rows = data.table.body;

                    if (data.row.index === rows.length - 1) {
                      pdf.setDrawColor('#E5E6E8');
                      pdf.setLineWidth(0.5);
                      pdf.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height);
                    }
                  }
                });
                summaryTable = [];

                if (order.netValue) {
                  summaryTable.push((0, _tables.createSubtotalTable)(order, translate, lang));
                }

                if (order.vat) {
                  summaryTable.push.apply(summaryTable, (0, _toConsumableArray2["default"])((0, _tables.createVatTable)(order, translate, lang)));
                }

                if (order.grossValue) {
                  summaryTable.push.apply(summaryTable, (0, _toConsumableArray2["default"])((0, _tables.createTotalTable)(order, translate, lang)));
                }

                vatIndex = 0;
                pdf.autoTable({
                  styles: {
                    fontSize: 9
                  },
                  theme: 'plain',
                  margin: {
                    left: 42,
                    right: 38
                  },
                  body: summaryTable,
                  willDrawCell: function willDrawCell(data) {
                    data.cell.y -= 10;
                    var columns = data.table.columns;
                    var rows = data.table.body;

                    if (data.row.index === rows.length - 3) {
                      if (data.column.index === columns.length - 1 || data.column.index === columns.length - 2) {
                        pdf.setDrawColor('#E5E6E8');
                        pdf.setLineWidth(0.5);
                        pdf.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height);
                      }
                    }

                    if (data.cell.raw.content === translate('pdf.invoice.table.vat')) {
                      vatIndex += 1;
                      setTextColor('#757575');
                      pdf.text("(".concat(order.vat[vatIndex - 1].percentage, "%)"), data.cell.x + data.cell.contentWidth + 2, data.cell.y + 10);
                      setTextColor('#010101');
                    }

                    if (data.cell.raw.content === translate('pdf.invoice.table.subTotal')) {
                      setTextColor('#757575');
                      pdf.text(translate('pdf.invoice.excludeVat'), data.cell.x + data.cell.contentWidth + 2, data.cell.y + 10);
                      setTextColor('#010101');
                    }
                  }
                });
                totalPages = pdf.internal.getNumberOfPages();

                if (notes) {
                  pdf.setPage(totalPages);
                  pdf.setFont('Montserrat');
                  pdf.setFontSize(8);
                  setTextColor('#010101');
                  pdf.text(translate('pdf.invoice.notes'), 38, pdf.internal.pageSize.getHeight() - 122);
                  pdf.setFontSize(7);
                  setTextColor('#757575');
                  pdf.text(notes.split('\n'), 38, pdf.internal.pageSize.getHeight() - 112, {
                    maxWidth: pdf.internal.pageSize.getWidth() * 0.32
                  });
                }

                for (i = 1; i <= totalPages; i++) {
                  pdf.setPage(i);
                  pdf.setDrawColor('#F2F2F2');
                  pdf.setLineWidth(1);
                  pdf.line(0, pdf.internal.pageSize.getHeight() - 40, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight() - 40);
                  pdf.setFont('Montserrat');
                  pdf.setFontSize(7);
                  setTextColor('#757575');
                  pdf.text(translate('pdf.invoice.footer', {
                    merchant: merchant === null || merchant === void 0 ? void 0 : merchant.name
                  }), 37, pdf.internal.pageSize.getHeight() - 25, {
                    maxWidth: 250
                  });
                  pdf.text("Page ".concat(i, "/").concat(totalPages), pdf.internal.pageSize.getWidth() - 60, pdf.internal.pageSize.getHeight() - 25);
                }

                if (!(returnType === 'save')) {
                  _context.next = 45;
                  break;
                }

                return _context.abrupt("return", resolve(pdf.save("Invoice-".concat(id, ".pdf"))));

              case 45:
                return _context.abrupt("return", resolve(pdf.output(returnType)));

              case 46:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  });
};

exports["default"] = createInvoice;